{
  "title": "Today",
  "attention": {
    "title": "Waiting for a person",
    "sub": "Handed off by the AI, asked for by the customer, or an order waiting for approval",
    "countMore": "{{count}}+",
    "openInbox": "Open inbox",
    "emptyTitle": "No chats waiting for a person",
    "emptyBody": "Chats the AI hands off, customers who ask for a person and orders waiting for approval show up here. Answering one clears it.",
    "loadError": "Couldn't load chats waiting for a person",
    "noPreview": "—"
  },
  "ai": {
    "title": "AI today",
    "on": "Answering customers",
    "off": "Turned off",
    "used": "{{percent}}% of today's quota used",
    "settings": "AI assistant settings",
    "loadError": "Couldn't load AI usage"
  },
  "orders": {
    "title": "Waiting for payment",
    "viewAll": "View all orders",
    "emptyTitle": "No orders waiting for payment",
    "emptyBody": "Orders created from chats that haven't been paid yet show up here.",
    "loadError": "Couldn't load orders",
    "noCustomer": "No customer",
    "items_one": "{{count}} item",
    "items_other": "{{count}} items"
  },
  "channels": {
    "title": "Chat channels",
    "manage": "Manage channels",
    "connected": "Connected",
    "reconnect": "Needs reconnecting",
    "inactive": "Off",
    "emptyTitle": "No channels connected yet",
    "emptyBody": "Connect LINE OA, Facebook or Instagram to start receiving chats.",
    "connect": "Connect a channel",
    "loadError": "Couldn't load channels"
  },
  "plan": {
    "title": "Plan",
    "manage": "Manage plan",
    "daysUnit": "days left"
  }
}
